export enum LOCATION_STORES_QUERIES_ENUMS {
  LOCATION_STORES_LIST = 'LOCATION_STORES_LIST',
  PLACE_PICKER_STORES_LIST = 'PLACE_PICKER_STORES_LIST',
  STORE_URLS = 'STORE_URLS',
  LOCATION_STORES_TEMPLATE = 'LOCATION_STORES_TEMPLATE',
}
